export function clearKeyPickupAddressWhenNotOrdered(
    other: any,
    hasKeyProductSelected: boolean
): void {
    if (!other || hasKeyProductSelected) return;

    other.keyPickupAddress = '';
    other.keyPickupZip = '';
    other.keyPickupCity = '';
}

export function hasKeyPickupProductSelected(products: any[]): boolean {
    return (products || []).some(
        (product: any) => product && product.selected && product.hasProductPropertyKeyPickup
    );
}
